import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga4';
import styled from 'styled-components';

// Import components
import { Button, Field as FormField } from 'components/elements';

const LoginFormFields = ({ isSubmitting }) => {
	// Get translation
	const { t } = useTranslation();

	return (
		<React.Fragment>
			<Field
				data-testid="login-form-filed-login"
				placeholder="login"
				name="login"
				type="text"
				component={FormField}
			/>
			<Field
				data-testid="login-form-field-password"
				placeholder="hasło"
				name="password"
				type="password"
				component={FormField}
			/>
			<SubmitButton
				onClick={() =>
					ReactGA.event({
						category: 'Login',
						action: 'User pressed the login button'
					})
				}
				data-testid="login-form-submit"
				type="submit"
				disabled={isSubmitting}
				width="100%"
				modifiers="primary"
			>
				{t('common_login_login_form_title')}
			</SubmitButton>
		</React.Fragment>
	);
};

const SubmitButton = styled(Button)`
	margin-top: 0.8rem;
`;

LoginFormFields.propTypes = {
	isSubmitting: PropTypes.bool.isRequired
};

export default React.memo(LoginFormFields);
